// extracted by mini-css-extract-plugin
export default {"cardResource":"LnCHY","img":"iIoWb","cardResourceInfo":"BU2SM","title":"jPDsF","description":"XhREG","cta":"GdFx+","horizontal":"O6y5r"};